/**
 * Configuration service request model.
 *
 * @param {Object} state Data model object
 * @param {string} state.password
 * @param {string} state.server
 * @param {string} state.username
 */

const request = state => ({
  Password: state.password,
  Server: state.server,
  Username: state.username,
});

export default {
  request,
};
